import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface DialogData {
  name: string;
  rename: boolean;
}

@Component({
  selector: 'app-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.scss']
})
export class ReportDialogComponent implements OnInit {

  myGroup: UntypedFormGroup;

  constructor(public dialogRef: MatDialogRef<ReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {
    this.myGroup = new UntypedFormGroup({
      name: new UntypedFormControl(this.data.name)
    });
    this.myGroup.controls['name'].setValidators([Validators.required]);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  checkName(control: UntypedFormControl) {
    if (control.value !== null) {
      return null;
    } else {
      return { err: true };
    }
  }
}
